import { apiPut } from "../baseApi";
import { setDomainData } from "service/mapper";

export const update = async (data, id) => {
  try {
    const response = await apiPut("_domain", id, data);
    return { ...response, data: setDomainData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
